var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExcelFile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 30,
    viewBox: "0 0 26 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.656 29.4946H3.53174V1.32886H18.5496V7.64872H24.656V29.4946Z",
    fill: "#FCFCFC",
    stroke: "#818181",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.626 7.75106L18.5195 1.43555L18.8607 1L24.9998 7.29664L24.626 7.75106Z",
    fill: "#818181"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8924 8.40088H1.45184C0.650012 8.40088 0 9.05089 0 9.85272V21.2932C0 22.0951 0.650012 22.7451 1.45184 22.7451H12.8924C13.6942 22.7451 14.3442 22.0951 14.3442 21.2932V9.85272C14.3442 9.05089 13.6942 8.40088 12.8924 8.40088Z",
    fill: "#107C42"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9569 20.2931H9.04553L3.3877 10.8503H5.33752L10.9569 20.2931Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.3877 20.2931H5.29905L10.9569 10.8503H9.00705L3.3877 20.2931Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5496 12.0703H15.0942V13.6027H18.5496V12.0703Z",
    fill: "#21A365"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8201 12.0703H19.3647V13.6027H22.8201V12.0703Z",
    fill: "#33C481"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5496 14.3843H15.0942V15.9167H18.5496V14.3843Z",
    fill: "#107C42"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8201 14.3843H19.3647V15.9167H22.8201V14.3843Z",
    fill: "#21A365"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5496 16.698H15.0942V18.2304H18.5496V16.698Z",
    fill: "#195D38"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8201 16.698H19.3647V18.2304H22.8201V16.698Z",
    fill: "#104B2B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelFile);
export default __webpack_public_path__ + "static/media/excel_file.455d2db796fc224e3734627c574b16bf.svg";
export { ForwardRef as ReactComponent };